import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Cta from "./cta"
import StyledImage from "./styled-image"

export default function SweetwaterRewards() {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        footer {
          sweetwaterRewards {
            description
            image {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 84)
                }
              }  
            }
            cta {
              url
              title
              target
            }
          }
        }
      }
    }
  `)
  const { image, description, cta } = data?.wpOption?.footer?.sweetwaterRewards



  return (
    <aside className={`py-6 md:py-9 bg-slate print:hidden`}>
      <div className="container">
        <div className="flex space-x-4 xl:space-x-6 justify-center">
          {image ?
            <div className="flex-shrink-0 flex-grow-0 ml-auto xl:ml-0 flex items-start">
              <StyledImage
                image={image}
                layout="fixed"
                className={``}
                objectFit={`contain`}
                imgClassName={'rounded'}
                width={84}
              />
            </div>
            : null}
          <div className="grid gap-x-4 xl:flex xl:flex-row xl:space-x-4 text-white justify-center">
            {description ? <div className="mb-4 max-w-4xl font-medium">{description}</div> : null}
            {cta && (
              <div className="xl:min-w-[20rem] flex xl:justify-center items-start">
                <Cta props={cta} className="btn btn-white-outline" arrow={true} />
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  )
}
